var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item.encodeItem.id},[_c('EncodeSmallCard',{attrs:{"item":item,"isEditMode":_vm.isEditMode},on:{"update:isEditMode":function($event){_vm.isEditMode=$event},"update:is-edit-mode":function($event){_vm.isEditMode=$event},"selected":_vm.selected}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }